import { getZonedDate } from '@eika-infrastruktur/date';
import selectTransferAccounts from '../../form/selectTransferAccounts';
import { TransferActionType } from './actions';
import { transferInitialState } from './state';
const reducer = (state, action) => {
    switch (action.type) {
        case TransferActionType.ACCOUNT_SELECTED:
            return selectTransferAccounts(state, action.payload);
        case TransferActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case TransferActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        case TransferActionType.SHOW_TO_ACCOUNTS:
            return {
                ...state,
                showToAccounts: true,
            };
        case TransferActionType.HIDE_TO_ACCOUNTS:
            return {
                ...state,
                showToAccounts: false,
            };
        case TransferActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case TransferActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case TransferActionType.OWN_TEXT:
            return {
                ...state,
                ownText: action.payload,
            };
        case TransferActionType.TRANSFER_DATE:
            return {
                ...state,
                transferDate: action.payload,
            };
        case TransferActionType.RESET:
            return {
                ...transferInitialState,
            };
        case TransferActionType.RESET_WITH_FROM_ACCOUNT:
            return {
                ...transferInitialState,
                fromAccount: action.payload,
                transferDate: getZonedDate(),
            };
        default:
            return state;
    }
};
const transferReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cTransfer form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default transferReducer;
//# sourceMappingURL=data:application/json;base64,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